import React from "react";

export class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      //window.location.href = '/patient_portal/dashboard/';
      return (
        <div className="error-boundary ">
          <h3>Something went wrong.</h3>
          <details style={{ whiteSpace: "pre-wrap" }}>
            {this.state.error && this.state.error.toString()}
            <br />
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}
